import React, { FC } from 'react';
import { TypographyProps, buttonClasses } from '@mui/material';
import {
    loadingButtonClasses,
} from '@mui/lab/LoadingButton';

import { ArrowDown24 } from '../../icons';
import { Typography } from '../Typography';
import { Button2, Button2Props } from '../Button2';


export type BaseDropdownButtonProps = Button2Props & {
    isOpen: boolean;
    isActive?: boolean;
    isLoading?: boolean;
    typographyProps?: TypographyProps;
};

export const BaseDropdownButton: FC<BaseDropdownButtonProps> = ({
    isOpen,
    isActive,
    isLoading,
    sx,
    children,
    endIcon,
    typographyProps,
    ...props
}) => (
    <Button2
        sx={{
            justifyContent: 'space-between',
            bgcolor: isOpen ? 'grayscale.shade20' : 'grayscale.shade10',
            color: isActive && !isOpen ? 'grayscale.shade100' : 'grayscale.shade85',
            px: 4,
            '&:hover:not(&:disabled)': {
                bgcolor: 'grayscale.shade20',
            },

            '&:focus': {
                bgcolor: 'grayscale.shade20',
            },

            '&:active': {
                bgcolor: 'grayscale.shade20',
            },

            '&:disabled': {
                bgcolor: 'grayscale.shade20',
            },

            [`&.${loadingButtonClasses.loading}`]: {
                bgcolor:
                    isOpen || isActive
                        ? 'grayscale.shade90'
                        : 'grayscale.shade20',

                [`> .${loadingButtonClasses.loadingIndicator}`]: {
                    color:
                        isOpen || isActive
                            ? 'grayscale.shade0'
                            : 'grayscale.shade95',
                },
            },

            [`& > .${buttonClasses.endIcon}`]: {
                ml: 0,
                mr: 0,
                color: isOpen ? 'grayscale.shade100' : 'grayscale.shade85',

                '> *:nth-of-type(1)': {
                    fontSize: '24px',
                },

                transition: ({ transitions }) =>
                    transitions.create(
                        ['transform', 'color', 'backgroundColor'],
                        {
                            duration: transitions.duration.standard,
                            easing: transitions.easing.easeInOut,
                        },
                    ),

                ...!endIcon && isOpen
                    ? {
                        transform: 'rotate(180deg)',
                        transformOrigin: 'center',
                    }
                    : {},
            },
            ...sx,
        }}
        loading={isLoading}
        loadingPosition='center'
        endIcon={endIcon || <ArrowDown24 />}
        disableRipple
        {...props}
    >
        <Typography variant='regularBody2' mr={3} {...typographyProps}>
            {children}
        </Typography>
    </Button2>
);
